import React from "react";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

function BannerSection({ history }) {
  const firestoreUser = useSelector(state => state.authState.firestoreUser);

  return (
    <section className="home-banner-area relative">
      <div className="container">
        {firestoreUser.anon ? (
          <div>
            <button
              className="primary-btn"
              id="register-btn"
              style={{ backgroundColor: "orange", borderRadius: "0" }}
              onClick={() => history.push("/signup")}
            >
              Register Now <span id="register-text">to get started</span>
            </button>
          </div>
        ) : null}
      </div>
    </section>
  );
}

export default withRouter(BannerSection);
